var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.104 12.187a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.437 10.52c-2.223 3.89-5 5.834-8.334 5.834-3.333 0-6.11-1.944-8.333-5.833 2.223-3.89 5-5.834 8.334-5.834 3.333 0 6.11 1.944 8.333 5.833z"
  }))));
};
export default SvgEye;